export default __webpack_public_path__ + "img/1080d7b1714200560975ea3bb4682860.svg";